<template>
    <div class="row mb-2">
        <div class="col-3"><el-input v-model="text.name" placeholder="Zeilen Beschreibung"></el-input></div>
        <div class="col-3"><el-input v-model="text.price1" placeholder="Text Preis 1"></el-input></div>
        <div class="col-3" v-if="priceCols == 2 || priceCols == 3"><el-input v-model="text.price2" placeholder="Text Preis 2"></el-input></div>
        <div class="col-3" v-if="priceCols == 3"><el-input v-model="text.price3" placeholder="Text Preis 3"></el-input></div>
    </div>
</template>

<script>
    export default{

        props: {
            text: Object,
            priceCols: Number
        },
    }
</script>
